<template>
  <div class="mx-8">
    <div>
      <div class="rounded bg-white border-customgrey">
        <div v-if="content.loading" class="p-8">
          <content-placeholders class="w-full">
            <content-placeholders-img class="w-full" id="iframe" />
          </content-placeholders>
        </div>
        <div class="p-8">
          <iframe
            v-if="quoteId"
            :src="form.pdf"
            frameborder="0"
            height="550"
            width="100%"
            @load="iframeLoad()"
          ></iframe>
        </div>
      </div>
    </div>
    <div class="bg-white border-t sticky bottom-0 z-50">
      <div v-if="content.loading" class="grid grid-cols-3 gap-4 p-4">
        <content-placeholders
          class="col-span-1 flex items-center justify-start"
        >
          <content-placeholders-img class="w-full px-8 py-4" />
        </content-placeholders>
        <content-placeholders
          class="col-span-1 flex items-center justify-center"
        >
          <content-placeholders-img class="w-full px-8 py-4" />
        </content-placeholders>
        <content-placeholders class="col-span-1 flex items-center justify-end">
          <content-placeholders-img class="w-full px-8 py-4" />
        </content-placeholders>
      </div>
      <div v-if="content.success" class="grid grid-cols-3 gap-4 p-4">
        <div class="col-span-1 flex items-center justify-start">
          <button
            @click.prevent="back()"
            :disabled="ui.loading"
            class="py-4 px-8 rounded transition-all duration-500 ease-in-out transform hover:scale-95"
          >
            <span class="font-semibold text-gray-500">Back</span>
          </button>
        </div>
        <div class="col-span-1 flex items-center justify-center">
          <button
            @click.prevent="save()"
            :disabled="ui.loading"
            class="px-8 py-4 transition-all duration-500 ease-in-out transform hover:scale-95"
          >
            <template v-if="!actions.save.ui.loading">
              <p class="text-primary font-semibold leading-none">
                Save and close
              </p>
            </template>
            <template v-else>
              <LoadingSpinner
                class="fill-current text-primary text-opacity-75 inline-block h-6 w-6"
              />
            </template>
          </button>
        </div>
        <div class="col-span-1 flex items-center justify-end">
          <button
            @click.prevent="download()"
            :disabled="actions.submit.ui.loading"
            :class="{
              'bg-warmgrey-400': actions.submit.ui.loading
            }"
            class="bg-primary px-8 py-4 rounded transition-all duration-500 ease-in-out transform hover:scale-95"
          >
            <template v-if="!actions.submit.ui.loading">
              <p class="text-white font-semibold leading-none">Download</p>
            </template>
            <template v-else>
              <LoadingSpinner
                class="fill-current text-white text-opacity-75 h-6 w-6"
              />
            </template>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import pdf2base64 from "pdf-to-base64";
import { API_URL } from "~/.env";
import { saveQuoteToCRM } from "~/api";

export default {
  name: "PreviewQuote",

  data() {
    return {
      content: {
        loading: true,
        success: false,
        error: null
      },

      actions: {
        back: {
          ui: {
            loading: false
          }
        },
        save: {
          ui: {
            loading: false
          }
        },
        submit: {
          ui: {
            loading: false
          }
        }
      },

      ui: {
        loading: false,
        success: false,
        error: null
      },

      showIframe: false,

      form: {
        pdf: null
      }
    };
  },

  computed: {
    ...mapGetters({
      quoteId: "quoteForm/id",
      quoteRecord: "quoteForm/record"
    }),

    pdfURL() {
      return `${API_URL}/api/v1/quotes/${this.quoteId}/pdf`;
    }
  },

  mounted() {
    this.getPDF();
  },

  methods: {
    /*
    async submit() {
      try {
        this.ui.loading = true;
        this.ui.success = false;
        this.ui.error = null;

        //await this.validate();
        //await this.updateQuote();
        await this.next();

        setTimeout(() => {
          this.ui.success = true;
        }, 3000);
      } catch (e) {
        console.error(e);
        this.ui.error = e;
      } finally {
        setTimeout(() => {
          this.ui.loading = false;
        }, 3000);
      }
    },
    */

    async getPDF() {
      console.log('this.quoteId', this.quoteId)
      if (this.quoteId) {
        let response = await pdf2base64(`${API_URL}/api/v1/quotes/${this.quoteId}/pdf`);
        this.form.pdf = "data:application/pdf;base64," + response;
      }
    },

    iframeLoad() {
      this.content.success = true;
      this.content.loading = false;
      this.content.error = null;
    },

    back() {
      this.$router.push({
        name: "quote.summary",
        params: { id: this.quoteId }
      });
    },

    async save() {
      try {
        this.actions.save.ui.loading = true;
        this.ui.loading = true;
        this.ui.success = false;
        this.ui.error = null;

        //await this.validate();
        //await this.updateQuote();
        await this.close();

        setTimeout(() => {
          this.ui.success = true;
        }, 3000);
      } catch (e) {
        this.ui.error = e;
      } finally {
        this.ui.loading = false;
        this.actions.save.ui.loading = false;
      }
    },

    close() {
      window.Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Your progress has been saved.",
        text: "Now it's safe to close this window.",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      });
    },

    download() {
      window.Swal.fire({
        title: "Save & download",
        text: "This action will save the Quote in the CRM.",
        icon: "warning",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#EC1D3C",
        cancelButtonColor: "#AFBAC9",
        confirmButtonText: "Yes, save and download"
      }).then(async result => {
        if (result.value) {
          const data = await saveQuoteToCRM(this.quoteId)

          await this.getPDF();

          let link = document.createElement("a");
          link.download = data.response.Quote_No + ".pdf";
          link.href = this.form.pdf;
          link.click();

          window.Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Well done!",
              text: "The Quote has been saved. Now, you can close this window.",
              showConfirmButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false
            });
        }
      });
    },

    next() {
      setTimeout(() => {
        this.$router.push({
          name: "quote.send",
          params: { id: this.quoteId }
        });
      }, 1500);
    }
  }
};
</script>

<style lang="scss" scoped>
.vue-content-placeholders-img {
  @apply h-12;
}
.vue-content-placeholders-img#iframe {
  @apply h-144;
}
.vue-content-placeholders-img.button {
  @apply w-56;
}
</style>
